module.exports = __webpack_public_path__ + "img/home_business_item6.37de1e54.jpg";